import { render, staticRenderFns } from "./LeadFlowManualCommunicationForm.vue?vue&type=template&id=27cdc9a6&scoped=true&"
import script from "./LeadFlowManualCommunicationForm.vue?vue&type=script&lang=js&"
export * from "./LeadFlowManualCommunicationForm.vue?vue&type=script&lang=js&"
import style0 from "./LeadFlowManualCommunicationForm.vue?vue&type=style&index=0&id=27cdc9a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cdc9a6",
  null
  
)

export default component.exports